import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        refreshAfter: Number,
        refreshUrl: String,
    }

    headers = { Accept: 'text/vnd.turbo-stream.html' }
    refreshTimeoutId = null
    abortController = null
    isRequestInFlight = false

    connect() {
        // If something breaks and cannot get the value from the server we do not want to go into an infinite loop
        if (!this.hasRefreshAfterValue) {
            this.refreshAfterValue = 60000
        }
        this.scheduleRefresh()
    }

    // On page change we abort any requests and clear the timer. This prevents
    // repeated queued requests slowing down page loads and the widget from
    // flickering.
    disconnect() {
        this.clearRefreshTimer()
        this.abortActiveRequest()
    }

    scheduleRefresh() {
        this.clearRefreshTimer()
        this.refreshTimeoutId = window.setTimeout(() => this.fetchData(), this.refreshAfterValue)
    }

    clearRefreshTimer() {
        if (!this.refreshTimeoutId) {
            return
        }

        clearTimeout(this.refreshTimeoutId)
        this.refreshTimeoutId = null
    }

    abortActiveRequest() {
        if (!this.abortController) {
            return
        }

        this.abortController.abort()
        this.abortController = null
    }

    fetchData() {
        if (this.isRequestInFlight) {
            return
        }

        this.isRequestInFlight = true
        this.abortActiveRequest()
        this.abortController = new AbortController()

        fetch(this.refreshUrlValue, {
            headers: this.headers,
            signal: this.abortController.signal,
        })
            .then((value) => value.text())
            .then((turboStreamsMsg) => {
                // Turbo is provided globally via turbo-rails
                const turbo = window.Turbo

                if (turbo && typeof turbo.renderStreamMessage === 'function') {
                    turbo.renderStreamMessage(turboStreamsMsg)
                }
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    console.error('widgets-refresh-after fetch failed', error)
                }
            })
            .finally(() => {
                this.isRequestInFlight = false
                this.abortController = null
            })
    }
}
